import React from "react";

export function Alert({ variant = "info", className = "", children, ...props }) {
	return (
		<div className={`grader-alert grader-alert--${variant} ${className}`.trim()} {...props}>
			{children}
		</div>
	);
}

export function AlertTitle({ className = "", ...props }) {
	return <h5 className={`font-semibold mb-2 ${className}`.trim()} {...props} />;
}

export function AlertDescription({ className = "", ...props }) {
	return <div className={`text-sm ${className}`.trim()} {...props} />;
}
